export default "__VITE_ASSET__DJp3Qcvh__"